import Const from 'constants';
import {initSportConfig} from 'helpers/common-helper';
import {getTeamNamesOfGames} from 'helpers/game-helper';
import {generateSignature} from 'helpers/hash';

let sportConfig = initSportConfig();

const defaultCombinationsState = {
    '5vs1': {
        checked: true,
        exposure: 0,
        firstTeamName: '',
        firstTeamPlayersQuantity: 5,
        secondTeamName: '',
        secondTeamPlayersQuantity: 1,
    },
    '4vs2': {
        checked: true,
        exposure: 0,
        firstTeamName: '',
        firstTeamPlayersQuantity: 4,
        secondTeamName: '',
        secondTeamPlayersQuantity: 2,
    },
    '4vs1': {
        checked: true,
        exposure: 0,
        firstTeamName: '',
        firstTeamPlayersQuantity: 4,
        secondTeamName: '',
        secondTeamPlayersQuantity: 1,
    },
    '3vs3': {
        checked: true,
        exposure: 0,
        firstTeamName: '',
        firstTeamPlayersQuantity: 3,
        secondTeamName: '',
        secondTeamPlayersQuantity: 3,
    },
    '3vs2': {
        checked: true,
        exposure: 0,
        firstTeamName: '',
        firstTeamPlayersQuantity: 3,
        secondTeamName: '',
        secondTeamPlayersQuantity: 2,
    },
    '2vs4': {
        checked: true,
        exposure: 0,
        firstTeamName: '',
        firstTeamPlayersQuantity: 2,
        secondTeamName: '',
        secondTeamPlayersQuantity: 4,
    },
    '2vs3': {
        checked: true,
        exposure: 0,
        firstTeamName: '',
        firstTeamPlayersQuantity: 2,
        secondTeamName: '',
        secondTeamPlayersQuantity: 3,
    },
    '1vs5': {
        checked: true,
        exposure: 0,
        firstTeamName: '',
        firstTeamPlayersQuantity: 1,
        secondTeamName: '',
        secondTeamPlayersQuantity: 5,
    },
    '1vs4': {
        checked: true,
        exposure: 0,
        firstTeamName: '',
        firstTeamPlayersQuantity: 1,
        secondTeamName: '',
        secondTeamPlayersQuantity: 4,
    },
};

function getCombinationsStateBySite(site, sport) {
    let comboKeys = [];
    if (Const.SITE_DK === site) {
        comboKeys = ['5vs1', '4vs2', '3vs3', '2vs4', '1vs5'];
    } else if (Const.SITE_FD === site) {
        comboKeys = inArray(sport, ['cfb', 'mlb', 'nba', 'nfl', 'nhl'])
          ? ['5vs1', '4vs2', '3vs3', '2vs4', '1vs5']
          : ['4vs1', '3vs2', '2vs3', '1vs4'];
    } else if (Const.SITE_YAHOO === site) {
        comboKeys = ['4vs1', '3vs2', '2vs3', '1vs4'];
    }

    const combinationsState = {};
    comboKeys.map((comboKey) => {
        combinationsState[comboKey] = {...defaultCombinationsState[comboKey]};
    });

    return {...combinationsState};
}

let combinationsState = getCombinationsStateBySite(sportConfig['site'], sportConfig['sport']);

const defaultState = {
    enabled: false,
    signature: null,
    data: {
        combinations: cp(combinationsState),
    },
    isEnabled() {
        return this.enabled;
    },
    getStateId() {
        return 'SinglegameForcedStacking.Settings';
    },
    getCombinations() {
        return {...this.data.combinations};
    },
    getCheckedCombinations() {
        const combos = {};
        Object.keys(this.data.combinations).map((comboKey) => {
            const combo = this.data.combinations[comboKey];
            if (combo.checked) {
                combos[comboKey] = {...combo};
            }
        });
        return combos;
    },
    isCombinationChecked(key) {
        return this.data.combinations[key].checked;
    },
    getCombinationExposure(key) {
        return this.data.combinations[key].exposure;
    },
    getSignature() {
        return this.signature;
    },
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case Const.SINGLEGAME_FORCED_STACKING_IS_USED:
            state = {...state};
            state.enabled = Boolean(action.use);

            return state;

        case Const.SINGLEGAME_FORCED_STACKING_SET_COMBO_IS_CHECKED:
            state = {...state};

            {
                const combination = state.data.combinations[action.comboKey];
                combination.checked = action.checked;
            }

            return state;

        case Const.SINGLEGAME_FORCED_STACKING_SET_COMBO_EXPOSURE:
            state = {...state};

            {
                const combination = state.data.combinations[action.comboKey];
                combination.exposure = action.exposure;
            }

            return state;

        case Const.GET_GAMES_SUCCESS:
            state = {...state};

            {
                const [firstTeamName = '', secondTeamName = ''] = getTeamNamesOfGames(action.data);

                Object.values(state.data.combinations).map((combination) => {
                    combination.firstTeamName = firstTeamName;
                    combination.secondTeamName = secondTeamName;
                });
            }

            return state;

        case Const.FILTER_BY_SPORT:
            combinationsState = getCombinationsStateBySite(action.site, action.sport);

            return {
                ...defaultState,
                data: {
                    combinations: cp(combinationsState),
                },
                enabled: false,
                signature: generateSignature(),
            };

        case Const.RESET_ALL_SETTINGS:
            const {combinations} = state.data;

            Object.values(combinations).map((combination) => {
                combination.checked = true;
                combination.exposure = 0;
            });

            return {
                ...defaultState,
                data: {
                    combinations,
                },
                enabled: false,
                signature: generateSignature(),
            };

        case Const.FILTER_BY_SLATE:
            return {
                ...defaultState,
                data: {
                    combinations: cp(combinationsState),
                },
                enabled: false,
                signature: generateSignature(),
            };

        default:
            return state;
    }
}
